// @flow

import styled, { css } from 'styled-components';
import media from '../../../helpers/media';
import type { Theme } from '../../../types';
import type { ColorScheme } from '../../../types/theme';

type Props = {
  scheme: ColorScheme,
};

const Title = styled<any, Theme, Props>('h3')`
  font-family: ${props => (props.theme.list.title.fontFamily ? props.theme.list.title.fontFamily : 'inherit')};
  font-size: ${props => props.theme.list.title.fontSize.default};
  line-height: 1.2;
  margin-bottom: 0.5em;
  color: ${({ scheme }) => scheme.heading};

  ${media.md(css`
    font-size: ${props => props.theme.list.title.fontSize.md};
  `)};
  ${media.lg(css`
    font-size: ${props => props.theme.list.title.fontSize.lg};
  `)};
`;

export default Title;
